import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectUserNodeInfo (state) {
  return state.userNodeInfo || Map()
}

export function selectUserNodeInfoById (state, { id }) {
  const userNodeInfoState = selectUserNodeInfo(state)
  return userNodeInfoState.get(id) || Map()
}
